import React from 'react';
import {getDate, useStyles} from './helper';

const PaymentItem = ({item, array}) => {
    const classes = useStyles();

    const Component = ({event_date, tag, sum, login_user, groups}) => (
        <div className={classes.root}>
                <span className={classes.date}>{getDate(event_date)}</span>
                <span className={classes.tag}>{tag}</span>
                <span>{login_user}({groups})</span>
                <span className={classes.sum}>{sum}</span>
            </div>
    )

    if (array) {
        const {login_user, groups, summ, event_date} = item[0];
        const {summ: summ2} = item[1];
        return (
            <Component 
                event_date={event_date} 
                tag="Акция" 
                sum={`${new Intl.NumberFormat('ru-RU').format(summ ? summ.toFixed(2) : summ)} + ${new Intl.NumberFormat('ru-RU').format(summ2 ? summ2.toFixed(2) : summ2)}`} 
                login_user={login_user}
                groups={groups}
            />
        )
    }
    const {summ} = item;
    if (summ) {
        const {login_user, groups, air, air_type, event_date} = item;
        return (
            <Component 
                event_date={event_date} 
                tag={air ? air_type && air_type === 'lifting' ? 'Статус' : air_type === 'present' ? 'Подарок' : 'Наличные' : 'Наличные'}
                sum={new Intl.NumberFormat('ru-RU').format(summ ? summ.toFixed(2) : summ)}
                login_user={login_user}
                groups={groups}
            />
        )
    }
    return <></>

}

export default PaymentItem;